import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Header from "../../../components/common/secondary header/index";
import OverallReport from "./overall-report";
import SubTopicWiseReport from "./sub-topic-report";
import Main from "../../../layout/main";
import "./style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { getQueryStringParams } from "../../../helpers";
import { textIdentifier } from "../../../textIdentifier";

export default function ReportByStudent() {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const {
    selectedCompetition,
    selectedSchool,
    selectedClass,
    selectedStudent,
    lang
  } = useSelector((state) => state.main);
  const location = useLocation();

  useEffect(() => {
    if (
      !selectedCompetition ||
      !selectedSchool ||
      !selectedClass ||
      !selectedStudent
    ) {
      navigate("/");
    }
  }, []);

  const renderCardJSX = () => {
    switch (activeTab) {
      case 1:
        return <SubTopicWiseReport />;
      default:
        return <OverallReport />;
    }
  };

  const handleTabChange = () => setActiveTab((pre) => (pre === 0 ? 1 : 0));

  if (
    !selectedCompetition ||
    !selectedSchool ||
    !selectedClass ||
    !selectedStudent
  ) {
  return null
  }
  return (
    <Fragment>
      <Header redirect={!!getQueryStringParams(location.search).redirect?getQueryStringParams(location.search).redirect:null} title={selectedCompetition && selectedCompetition.name} />

      <Main className="report-school-classes">
        {/* heading card */}
        <div className="card heading-card">
          <div className="card-body">
            <span className="card-title">
              <span
                onClick={() => {
                  navigate(
                    `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes`
                  );
                }}
              >
                {selectedSchool.name}
              </span>{" "}
              /{" "}
              <span
                onClick={() => {
                  navigate(
                    `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${selectedClass.id}/students`
                  );
                }}
              >
                {selectedClass.name}
              </span>{" "}
              /{" "}
              <span>
                <span>
                  {selectedStudent.first_name} {selectedStudent.last_name}{" "}
                </span>
                <span className="text-primary">
                  ({textIdentifier["rank"][lang]} {selectedStudent.rank})
                </span>
              </span>
            </span>
          </div>
        </div>

        {/* heading card */}

        {/* content */}
        <div className="cr-wrapper-card">
          <div className="cr-card-header">
            <button
              onClick={handleTabChange}
              className={
                activeTab === 0
                  ? "btn-contained bg-primary"
                  : "btn-outlined bg-transparent"
              }
            >
              {textIdentifier["overall-report"][lang]}
            </button>
            <button
              onClick={handleTabChange}
              className={
                activeTab === 1
                  ? "btn-contained bg-primary"
                  : "btn-outlined bg-transparent"
              }
            >
             {textIdentifier["subtopic-wise-report"][lang]}
            </button>
          </div>

          {renderCardJSX()}
        </div>
      </Main>
    </Fragment>
  );
}
